import angular from 'angular'

angular.module('nominas.empresasconceptos')
  .config(function ($stateProvider) {
    $stateProvider.state('nominas.empresasconceptos', {
      url: '/empresasconceptos?:id_proyecto',
      template: '<nominas-empresasconceptos id-proyecto="idProyecto"></nominas-empresasconceptos>',
      controller: function ($scope, idProyecto) {
        $scope.idProyecto = idProyecto;
      },
      data: {
        title: 'Empresas - Conceptos',
      },
      resolve: {
        idProyecto: function ($stateParams) {
          return $stateParams.id_proyecto;
        },
      },
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/empresasconceptos/routes/nominas-empresasconceptos.js